


































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal, BCarousel } from 'bootstrap-vue';
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import { Sheet, SheetField, Examinee, SheetActivity, FieldActivity, ScoreOption } from "../../modules/teacher/SaitenList";

const ModalImageKindEnum = Object.freeze({Scan: 1, Result: 2});

export interface Data {
  sheet_id: string
  sheet: Sheet | null
  sheetFields: SheetField[] | null
  examinees: Examinee[] | null
  studentCodeWidth: number
  studentNameWidth: number
  rightTableTdWidth: string
  colspan: number
  totalScoreAverage: number
  totalScoreRate: number
  totalFieldCount: number
  totalSaitenCompletedCount: number
  totalPendingCount: number
  delayedJobCount: number
  isSaitenCompleted: boolean
  isStudentNoSortDesc: boolean
  isTotalScoreSortDesc: boolean
  isFieldScoreSortDest: boolean
  isDispTds: boolean[]
  ModalImageKindEnum: Readonly<{Scan: number; Result: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number; Pending: number}>
  windowHeight: number
  scoreOptions: ScoreOption[]
  errors: string[]
  isScanImageVisible: boolean
  scanImageExamineeIds: number[]
  previewScanImageExamineeId: number
  isResultImageVisible: boolean
  resultImageExamineeIds: number[]
  previewResultImageExamineeId: number
  isPdfDownloadSingleFile: boolean
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "preview-image-sidebar": PreviewImageSidebar,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: null,
      sheetFields: new Array<SheetField>(),
      examinees: new Array<Examinee>(),
      studentCodeWidth: 0,
      studentNameWidth: 0,
      rightTableTdWidth: "",
      colspan: 4,
      totalScoreAverage: 0,
      totalScoreRate: 0,
      totalFieldCount: 0,
      totalSaitenCompletedCount: 0,
      totalPendingCount: 0,
      delayedJobCount: 0,
      isSaitenCompleted: false,
      isStudentNoSortDesc: false,
      isTotalScoreSortDesc: false,
      isFieldScoreSortDest: false,
      isDispTds: [],
      CorrectStateEnum: Common.CorrectStateEnum,
      ModalImageKindEnum: ModalImageKindEnum,
      windowHeight: 0,
      scoreOptions: new Array<ScoreOption>(),
      errors: [],
      isScanImageVisible: false,
      scanImageExamineeIds: [],
      previewScanImageExamineeId: null,
      isResultImageVisible: false,
      resultImageExamineeIds: [],
      previewResultImageExamineeId: null,
      isPdfDownloadSingleFile: false,
    });

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      state.windowHeight = windowHeight;

      if(tableArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * テーブルスクロールイベント
     ************************************************************/

    const scrollChanged = () => {
      const topRightTableArea: Element = document.getElementById("top-right-table-area");
      const bottomLeftTableArea: Element = document.getElementById("bottom-left-table-area");
      const bottomRightTableArea: Element = document.getElementById("bottom-right-table-area");

      topRightTableArea.scrollLeft = bottomRightTableArea.scrollLeft;
      bottomLeftTableArea.scrollTop = bottomRightTableArea.scrollTop;
    };

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 画像作成ボタン押下
     ************************************************************/

    const createPdfJob = async () => {
      if(!window.confirm("採点画像作成を実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/saiten_list/create_pdf_job/${state.sheet_id}`).then(response => {
        alert("採点画像作成を開始しました");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 集計ボタン押下
     ************************************************************/

    const sumup = async () => {
      if(!window.confirm("集計処理を実行します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/saiten_list/sumup`, {sheet_id: state.sheet_id}).then(response => {
        alert(`集計処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 出席番号列でソート
     ************************************************************/

    const sortStudentNo = () => {
      state.isStudentNoSortDesc = !state.isStudentNoSortDesc;
      if(state.isStudentNoSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.student_no - b.student_no).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.student_no - b.student_no);
      }
    }

    /************************************************************
     * 合計得点列でソート
     ************************************************************/

    const sortTotalScore = () => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.score - b.score).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.score - b.score);
      }
    };

    /************************************************************
     * 設問列でソート
     ************************************************************/

    const sortFieldScore = (idx: number) => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b)).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b));
      }
    };

    /************************************************************
     * 設問列のソートロジック 得点でソートする
     * 誤答・未採点・欠席者を区別するため
     * ダミー特典として未採点は-1、欠席者は-2でソートする
     ************************************************************/

    const sortFieldScoreSub = (idx: number, e1: Examinee, e2: Examinee) => {
      let scoreA = 0, scoreB = 0;
      if(e1.fieldActivities.length > idx){
        scoreA = e1.fieldActivities[idx].score == null ? -1 : e1.fieldActivities[idx].score;
      }else{
        scoreA = -2;
      }
      if(e2.fieldActivities.length > idx){
        scoreB = e2.fieldActivities[idx].score == null ? -1 : e2.fieldActivities[idx].score;
      }else{
        scoreB = -2;
      }
      return scoreA - scoreB;
    }

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertCaptureDate = (date: string) => {
      return date ? moment(date).format('Y年M月D日') : "-";
    };

    /************************************************************
     * ダウンロードヘッダチェックボックス変更イベント
     ************************************************************/

    const allSelectChanged = (changedVal: boolean) => {
      state.examinees.forEach(x => {
        x.checked = changedVal;
      });
    };

    /************************************************************
     * ダウンロードアイコン押下
     ************************************************************/

    const downloadPdf = async () => {

      const studentIds = state.examinees.filter(x => x.checked).map(x => x.student_no);
      if(studentIds.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("PDFをダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/saiten_list/download_pdf/${state.sheet_id}/${studentIds}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sheet_id}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * ペンシルアイコン押下 採点画面へ遷移
     ************************************************************/

    const saitenStart = (sheetField: SheetField) => {
      if(!context.root.$store.state.currentUser.scoring_auth){
        alert("採点権限がないため、採点画面を表示できません。");
        return;
      }
      context.root.$router.push(`/teacher_site/saiten_input/${state.sheet_id}/${sheetField.id}`).catch(err => {});
    }

    /************************************************************
     * 配点プルダウン変更
     ************************************************************/

    const allotChanged = async (sheetField: SheetField) => {

      if(!window.confirm("配点を変更しますか？")){
        sheetField.allot = sheetField.allotCache;
        return;
      }
      const param: object = {
        sheet_field_idx: state.sheetFields.indexOf(sheetField),
        allot: sheetField.allot
      };

      await http.post(`/api/saiten_list/update_allot/${state.sheet.base_sheet_id}`, param).then(response => {
        alert("配点の変更が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/saiten_list?sheet_id=${state.sheet_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.delayedJobCount = response.data.create_pdf_job_count

        const fieldActivities: FieldActivity[] = response.data.field_activities.map((x: any) => new FieldActivity(x));
        const sheetActivities: SheetActivity[] = new Array<SheetActivity>();
        response.data.sheet_activities.forEach((x: any) => {
          sheetActivities.push(new SheetActivity(x));
        });
        
        response.data.examinees.forEach((x: any, i: number) => {
          state.examinees.push(new Examinee(x, sheetActivities, fieldActivities, response.data.exists_result_image_student_nos, i + 1));
        });

        response.data.sheet_fields.forEach((x: any) => {
          state.sheetFields.push(new SheetField(x, fieldActivities));
        });

        let totalScore = Common.sumArray(state.examinees.map(x => x.score));
        const totalAllot = state.sheet.allot * state.examinees.length;
        state.totalScoreAverage = Number((totalScore / state.examinees.length).toFixed(1));
        state.totalScoreRate = Math.round(totalScore / totalAllot * 100);
        state.totalFieldCount = state.sheetFields.length * state.examinees.length;
        state.totalSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.saitenCompletedCount));
        state.isSaitenCompleted = state.totalSaitenCompletedCount == state.totalFieldCount;

        const studentCodeMaxLength = state.examinees.map(x => x.student_code == null ? 0 : String(x.student_code).length).reduce((a,b)=>Math.max(a,b));
        state.studentCodeWidth = studentCodeMaxLength > 3 ? studentCodeMaxLength * 20 : 65;
        const studentNameMaxLength = state.examinees.map(x => x.student_name == null ? 0 : x.student_name.length).reduce((a,b)=>Math.max(a,b));
        state.studentNameWidth = studentNameMaxLength > 3 ? studentNameMaxLength * 20 : 65;
        
        const fieldNames: string[] = state.sheetFields.map(x => `${x.part1}${x.part2}${x.part3}`.replace("null", ""));
        let fieldNameMaxLength = fieldNames.map(x => x.length).reduce((a,b)=>Math.max(a,b));
        state.rightTableTdWidth = `${fieldNameMaxLength > 3 ? fieldNameMaxLength * 20 : 80}px`;

        state.totalPendingCount = Common.sumArray(state.sheetFields.map(x => x.pendingCount));

        for(let i = 1; i <= 100; i++){
          state.scoreOptions.push(new ScoreOption(i, `${i}点`));
        }

        state.sheetFields.forEach(x => {
          state.isDispTds.push((context.root.$store.state.isPendingOnly && x.pendingCount > 0) || !context.root.$store.state.isPendingOnly);
        });

        if(context.root.$store.state.isPendingOnly && state.isDispTds.filter(x => x).length == 0){
          alert("保留データはありません。試験一覧に戻ります。");
          context.root.$store.dispatch("goSheetList");
        }

        state.scanImageExamineeIds = state.examinees.map(x => x.id);
        state.resultImageExamineeIds = state.examinees.filter(x => x.is_exists_result_image).map(x => x.id);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });
      
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      document.getElementById("bottom-right-table-area").onscroll = scrollChanged;
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    const showScanImage = (examinee: Examinee) => {
      state.previewScanImageExamineeId = examinee.id;
      state.isScanImageVisible = true;
    }

    const showResultImage = (examinee: Examinee) => {
      state.previewResultImageExamineeId = examinee.id;
      state.isResultImageVisible = true;
    }

    return {
      ...toRefs(state),
      convertExecDateText,
      createPdfJob,
      sumup,
      sortStudentNo,
      sortTotalScore,
      sortFieldScore,
      allSelectChanged,
      downloadPdf,
      saitenStart,
      allotChanged,
      convertCaptureDate,
      showScanImage,
      showResultImage,
    };
  }
})
